import React, { FC, FormEvent, useEffect, useState } from "react";
import { ResponseData } from "../adminpanel/panels/types/types";
import Table, { ColumnDefinitionType } from "../table/Table";
import FooterButtons from "../customhtmlcomponents/FooterButtons";
import axios from "../../services/ApiConfig";
import { AxiosResponse } from "axios";
import { useHistory } from "react-router-dom";
import { URLS } from "../../utility/UrlConstants";
import NavigationBar from "../NavigationBar";
import {
  IntlNubmerFormatter,
  removeWhiteSpaces,
} from "../../utility/formatInputField";
import LoadingSpinnerComponent from "../customhtmlcomponents/LoadingSpinnerComponent";

interface IKosProps {
  setCurrentForeningReportNumber: React.Dispatch<React.SetStateAction<number>>;
  currentForeningReportNumber: number;
  username: string;
  message: React.Dispatch<React.SetStateAction<{ body: ResponseData }>>;
  setModal: React.Dispatch<React.SetStateAction<boolean>>;
}

type KosDto = {
  foreningsNummer: string;
  kursOpplaeringRows: KursOpplaeringRowDto[];
};

enum MoteType {
  Sentralt = "SENTRALT",
  Fylke = "FYLKE",
  Lokal = "LOKAL"
}

type KursOpplaeringRowDto = {
  foreningsNummer: number;
  id: number;
  navn: string;
  antallDeltagere: number | string;
  antallMoter: number | string;
  moteType: MoteType;
};

export function isBlank(str: string) {
  return !str || /^\s*$/.test(str);
}

const get2024SentralArrangements = (foreningNummer: number, startId: number): KursOpplaeringRowDto[] => {
  const arrangements = [
    "Har foreningen deltatt på webinar i regi av NKS sentralt?, evt hvor mange (ca. deltagere)?",
    "Har noen i foreningen deltatt på et eller flere e-læringskurs i regi av sekretariatet, evt hvor mange? (ca deltagere)?",
  ]
  return arrangements.map((arrangement) => {
    return {
      foreningsNummer: foreningNummer,
      id: startId++,
      navn: arrangement,
      antallDeltagere: "",
      antallMoter: "",
      moteType: MoteType.Sentralt,
    }
  });
}

const get2024FylkeArrangements = (foreningNummer: number, startId: number): KursOpplaeringRowDto[] => {
  const arrangements = [
    "Fylkesårsmøte",
    "Informasjonsmøte i fylket/ fylkesvise samlinger",
    "Andre arrangement internasjonalt eller i fylket",
  ]
  return arrangements.map((arrangement, index) => {
    return {
      foreningsNummer: foreningNummer,
      id: startId++,
      navn: arrangement,
      antallDeltagere: "",
      antallMoter: "",
      moteType: MoteType.Fylke,
    }
  });
}

const get2023LokalArrangements = (foreningNummer: number, startId: number): KursOpplaeringRowDto[] => {
  const arrangements = [
    "Styremøte",
    "Arbeids- og medlemsmøter",
  ]
  return arrangements.map((arrangement, index) => {
    return {
      foreningsNummer: foreningNummer,
      id: startId++,
      navn: arrangement,
      antallDeltagere: "",
      antallMoter: "",
      moteType: MoteType.Lokal,
    }
  });
}

const Kos: FC<IKosProps> = ({
  currentForeningReportNumber,
  message,
  setModal,
  username,
}) => {
  const [kosDto, setKosDto] = useState<KosDto>({
    foreningsNummer: currentForeningReportNumber.toString(),
    kursOpplaeringRows: []
  });
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const onKosDtoReceived = (response: AxiosResponse<KosDto>) => {
    const { kursOpplaeringRows, foreningsNummer } =
      response.data;
    const rows = kursOpplaeringRows.map((item) => ({
      ...item,
      antallDeltagere: IntlNubmerFormatter(item.antallDeltagere as number),
      antallMoter: IntlNubmerFormatter(item.antallMoter as number),
    })) as KursOpplaeringRowDto[];

    const sentralRows = rows.filter(x => x.moteType === MoteType.Sentralt)

    if(sentralRows.length === 0){
      rows.push(...get2024SentralArrangements(currentForeningReportNumber, getNextId(rows)))
    }

    const fylkeRows = rows.filter(x => x.moteType === MoteType.Fylke)
    if(fylkeRows.length === 0){
      rows.push(...get2024FylkeArrangements(currentForeningReportNumber, getNextId(rows)))
    }

    const lokalRows = rows.filter(x => x.moteType === MoteType.Lokal)
    if(lokalRows.length === 0){
      rows.push(...get2023LokalArrangements(currentForeningReportNumber, getNextId(rows)))
    }

    const kosStateDto = {
      foreningsNummer: foreningsNummer,
      kursOpplaeringRows: rows
    };
    console.log(kosStateDto);
    setKosDto(kosStateDto);
  };

  const getNextId = (rows: KursOpplaeringRowDto[]) => {
    const maxId = Math.max(...rows.map(x => x.id))
    return rows.length < 1 ? 1 : maxId + 1
  }

  useEffect(() => {
    const getKos = async () => {
      setIsLoading(true);
      await axios
        .get(`${URLS.KOS_GET}${currentForeningReportNumber}`, {
          headers: {
            Accept: "application/json",
            "Content-type": "application/json",
          },
        })
        .then((response: AxiosResponse<KosDto>) => {
          console.log(response);
          onKosDtoReceived(response);
        })
        .catch((error) => console.log(error));
      setTimeout(() => setIsLoading(false), 500);
    };
    getKos();
  }, []);

  const history = useHistory();
  const saveSuccessMessage = () => {
    message({
      body: {
        body: {
          message: `Kurs og Opplæring ble lagret.`,
        },
      },
    });
    setModal(true);
    setTimeout(() => setModal(false), 1750);
  };
  const saveOnClick = async (e: React.BaseSyntheticEvent, link: string) => {
    postFormData(false)
  };

  const postFormData = async (redirectToNextPage: boolean) => {
    setIsSubmitting(true);
    console.log("Setting is submitting to true");
    const filteredDto = createFilteredDto();
    axios
      .post(URLS.KOS_POST, filteredDto, {
        headers: {
          Accept: "application/json",
          "Content-type": "application/json",
        },
      })
      .then((response) => {
        console.log(response);
        saveSuccessMessage();
        if(redirectToNextPage){
          setTimeout(
            () => {
              setIsSubmitting(false)
              history.push({
                pathname: "/gbm",
                state: currentForeningReportNumber,
              })
            },
            1750
          );
        }
      })
      .catch((error) => {
        console.log(error?.response?.data);
        message({
          body: {
            body: {
              error: "Dessverre feilet lagring av Kurs/Opplæring/Samarbeid. Vennligst sjekk at alle felter er fylt inn med rett verdi og prøv igjen.",
            },
          },
        });
        setModal(true);
        setTimeout(() => {
          setModal(false)
          setIsSubmitting(false)
        }, 5000);
      });
  }

  const filterOutEmptyRows = () => {
    const kursOpplaeringRows = kosDto.kursOpplaeringRows
      .slice()
      .filter((k) => !isBlank(k.navn));
    return { kursOpplaeringRows };
  };

  function createFilteredDto() {
    const { kursOpplaeringRows } =
      filterOutEmptyRows();
    const removeWhiteSpacesKursOpplaeringRows = kursOpplaeringRows.map(
      (kursOpplaeringRow) => ({
        ...kursOpplaeringRow,
        antallDeltagere: removeWhiteSpaces(
          kursOpplaeringRow.antallDeltagere.toString()
        ),
        antallMoter: removeWhiteSpaces(
          kursOpplaeringRow.antallMoter.toString()
        ),
      })
    );
    const dto = {
      ...kosDto,
      kursOpplaeringRows: removeWhiteSpacesKursOpplaeringRows,
    };
    return dto;
  }

  const submit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    postFormData(true)
  };

  const handleRowChange = (e: any, row: any) => {
    console.log("kosDto", kosDto.kursOpplaeringRows)
    const { name, value } = e.target;
    const { id } = row;

    const newItem = { ...row, [name]: value };
    const updatedRows = kosDto.kursOpplaeringRows.map(item =>
      item.id === id ? newItem : item
    );

    console.log("updated kosDto", updatedRows)


    setKosDto(prevState => ({
      ...prevState,
      kursOpplaeringRows: updatedRows,
    }));
  };

  const addRow = (moteType: MoteType) => {
    const newID = new Date().getMilliseconds().valueOf();
    const newRow: KursOpplaeringRowDto = {
      foreningsNummer: currentForeningReportNumber,
      id: newID,
      navn: "",
      antallDeltagere: "",
      antallMoter: "",
      moteType: moteType,
    };
    setKosDto((prevState) => ({
      ...prevState,
      kursOpplaeringRows: [...prevState.kursOpplaeringRows, newRow],
    }));
  };
  const removeRow = (id: number) => {
    let toRemove = kosDto.kursOpplaeringRows;
    if (toRemove.length === 1) {
      return;
    }
    const removed = toRemove.filter((kurs) => kurs.id !== id);
    setKosDto((prevState) => ({
      ...prevState,
      kursOpplaeringRows: removed,
    }));
  };
  const sentralArrangementColumns: ColumnDefinitionType<
    KursOpplaeringRowDto,
    keyof KursOpplaeringRowDto
  >[] = [
    {
      key: "navn",
      inputType: "text",
      header: "Navn på arrangement",
      colSpan: 3,
      isWide: true,
      editAsAdminOnly: true
    },
    {
      key: "antallDeltagere",
      inputType: "text",
      header: "Deltagere fra forening",
      textStyle: "flex text-right mr-0 ml-auto pr-2",
      isNumberField: true,
    },
  ];

  const fylkeArrangementColumns: ColumnDefinitionType<
    KursOpplaeringRowDto,
    keyof KursOpplaeringRowDto
  >[] = [
    {
      key: "navn",
      inputType: "text",
      header: "Navn på arrangement",
      editAsAdminOnly: true
    },
    {
      key: "antallDeltagere",
      inputType: "text",
      header: "Deltagere fra forening",
      isNumberField: true,
    }
  ];

  const lokalArrangementColumns: ColumnDefinitionType<
    KursOpplaeringRowDto,
    keyof KursOpplaeringRowDto
  >[] = [
    {
      key: "navn",
      inputType: "text",
      header: "Navn på arrangement",
      editAsAdminOnly: true
    },
    {
      key: "antallMoter",
      inputType: "text",
      header: "Antall møter",
      isNumberField: true,
    },
  ];

  const isAdmin = username === "1";
  const sentralRows = kosDto.kursOpplaeringRows.filter(x => x.moteType === MoteType.Sentralt);
  const fylkeRows = kosDto.kursOpplaeringRows.filter(x => x.moteType === MoteType.Fylke);
  const lokalRows = kosDto.kursOpplaeringRows.filter(x => x.moteType === MoteType.Lokal);

  console.log("sentralRows", sentralRows)
  console.log("fylkeRows", fylkeRows)
  console.log("lokalRows", lokalRows)

  return (
    <>
      <NavigationBar saveOnClick={saveOnClick} />
      {isLoading ? (
        <LoadingSpinnerComponent />
      ) : (
        <form onSubmit={submit}>
          <div className="bg-sk-tertiary-red">
            <div>
              <p className="text-black text-center text-2xl font-bold mt-2py-2 p">
                5. Kurs/opplæring og samarbeidsprosjekt
              </p>
            </div>
            {/*Main wrapper*/}
            <div className="flex flex-row m-auto w-full justify-center">
              {/*Table Number one starts here*/}
              <div className="mt-4 h-2/3 w-full flex-row  self-center justify-center bg-sk-button-selected border-2 border-sk-secondary-blue rounded-md shadow-2xl mb-8 pb-8 transform scale-100 md:scale-75 max-w-screen-2xl">
                <div>
                  <p className="text-black text-center text-2xl font-bold mt-4 py-2">
                    5.1 Deltagelse på arrangement, kurs og opplæring i regi av N.K.S. sentralt
                  </p>
                </div>
                <Table
                  handleChange={handleRowChange}
                  data={sentralRows}
                  columns={sentralArrangementColumns}
                  removeRow={removeRow}
                  addRow={() => addRow(MoteType.Sentralt)}
                  isAdmin={isAdmin}
                  rowActionsAsAdminOnly={true}
                />
              </div>
            </div>
            {/*Table Number two starts here*/}
            <div className="flex flex-row m-auto w-full justify-center mb-8 pb-8">
              <div className="mt-4 h-2/3 w-full self-center justify-center bg-sk-button-selected border-2 border-sk-secondary-blue rounded-md shadow-2xl pb-8 transform scale-100 md:scale-75 max-w-screen-2xl">
                <div>
                  <p className="text-black text-center text-2xl font-bold mt-4 py-2">
                    5.2 Møter, arrangement og prosjekt i regi av fylkesforeningen
                  </p>
                </div>
                <Table
                  handleChange={handleRowChange}
                  data={fylkeRows}
                  columns={fylkeArrangementColumns}
                  removeRow={removeRow}
                  addRow={() => addRow(MoteType.Fylke)}
                  isAdmin={isAdmin}
                  rowActionsAsAdminOnly={true}
                />
              </div>
            </div>
            {/*Table Number three starts here*/}
            <div className="flex flex-row m-auto w-full justify-center mb-8 pb-8">
              <div className="mt-4 h-2/3 w-full self-center justify-center bg-sk-button-selected border-2 border-sk-secondary-blue rounded-md shadow-2xl pb-8 transform scale-100 md:scale-75 max-w-screen-2xl">
                <div>
                  <p className="text-black text-center text-2xl font-bold mt-4 py-2">
                    5.3 Møter, arrangement og prosjekt i regi av lokalforeningen
                  </p>
                </div>
                <Table
                  handleChange={handleRowChange}
                  data={lokalRows}
                  columns={lokalArrangementColumns}
                  removeRow={removeRow}
                  addRow={() => addRow(MoteType.Lokal)}
                  isAdmin={isAdmin}
                  rowActionsAsAdminOnly={true}
                />
              </div>
            </div>
            {/*This is the go back and forward buttons*/}
            <FooterButtons
              previousLocation="/aktiviteter"
              saveOnClick={saveOnClick}
              isSubmitting={isSubmitting}
            />
          </div>
        </form>
      )}
    </>
  );
};
export default Kos;
